var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-tile-macro.j2"] = require( "macros/product-tile-macro.j2" );
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/slider-macros.j2"] = require( "macros/slider-macros.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-shop-the-look.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-tile-macro.j2", false, "product/templates/product-shop-the-look.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayProductTile")) {
var t_4 = t_1.displayProductTile;
} else {
cb(new Error("cannot import 'displayProductTile'")); return;
}
context.setVariable("displayProductTile", t_4);
env.getTemplate("macros/urls.j2", false, "product/templates/product-shop-the-look.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("productUrl")) {
var t_8 = t_5.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_8);
output += "\n\n";
var t_9;
t_9 = (lineno = 3, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "isFeatureEnabled"), "isFeatureEnabled", context, [runtime.contextOrFrameLookup(context, frame, "core"),"favorites"]));
frame.set("displayFavorites", t_9, true);
if(frame.topLevel) {
context.setVariable("displayFavorites", t_9);
}
if(frame.topLevel) {
context.addExport("displayFavorites", t_9);
}
output += "\n\n<div class=\"s-shop-the-look js-product-shop-the-look dom-product-shop-the-look\" data-qa-shop-the-look>";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"shopTheLook")) {
var t_10;
t_10 = (env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"shopTheLook")),"products")) < 4?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("isFullWidth", t_10, true);
if(frame.topLevel) {
context.setVariable("isFullWidth", t_10);
}
if(frame.topLevel) {
context.addExport("isFullWidth", t_10);
}
output += "\n\n        <div class=\"c-shop-the-look__title\">\n\n            <div class=\"o-row\">\n\n                <div class=\"o-column o-extra-small--12\">\n\n                    <h2 class=\"c-product-tile__h2\">\n\n                        ";
output += runtime.suppressValue((lineno = 19, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product-shop-the-look-title",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n\n                    </h2>\n\n                </div>\n\n            </div>\n\n            <div class=\"o-row\">\n\n                <div class=\"o-column o-extra-small--12 o-slider-product-tray__wrapper\">\n\n                    <div class=\"o-slider-product-tray o-slider-product-tray--shop-the-look-product-image js-slider--product-image u-centered-content ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "isFullWidth")?"o-slider-product-tray__full":""), env.opts.autoescape);
output += "\">\n\n                        <div class=\"o-slider-product-tray__inner js-slider__inner\">";
frame = frame.push();
var t_13 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"shopTheLook")),"products");
if(t_13) {var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("tile", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
var t_15;
t_15 = "PAGE_TYPE";
frame.set("stlEventCategory", t_15, true);
if(frame.topLevel) {
context.setVariable("stlEventCategory", t_15);
}
if(frame.topLevel) {
context.addExport("stlEventCategory", t_15);
}
output += "\n                                ";
var t_16;
t_16 = "rec tray shop-the-look|" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index");
frame.set("stlEventAction", t_16, true);
if(frame.topLevel) {
context.setVariable("stlEventAction", t_16);
}
if(frame.topLevel) {
context.addExport("stlEventAction", t_16);
}
output += "\n                                ";
var t_17;
t_17 = (lineno = 39, colno = 64, runtime.callWrap(t_8, "productUrl", context, [runtime.memberLookup((runtime.memberLookup((t_14),"product")),"productSlug"),runtime.memberLookup((runtime.memberLookup((t_14),"product")),"queryParams")]));
frame.set("stlEventLabel", t_17, true);
if(frame.topLevel) {
context.setVariable("stlEventLabel", t_17);
}
if(frame.topLevel) {
context.addExport("stlEventLabel", t_17);
}
output += "\n                                ";
var t_18;
t_18 = (lineno = 40, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [runtime.contextOrFrameLookup(context, frame, "stlEventCategory"),runtime.contextOrFrameLookup(context, frame, "stlEventAction") + "" + "|click",runtime.contextOrFrameLookup(context, frame, "stlEventLabel")]));
frame.set("analytics", t_18, true);
if(frame.topLevel) {
context.setVariable("analytics", t_18);
}
if(frame.topLevel) {
context.addExport("analytics", t_18);
}
output += "\n                                ";
var t_19;
t_19 = (lineno = 41, colno = 60, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [runtime.contextOrFrameLookup(context, frame, "stlEventCategory"),runtime.contextOrFrameLookup(context, frame, "stlEventAction") + "" + "|quickshop",runtime.contextOrFrameLookup(context, frame, "stlEventLabel")]));
frame.set("analyticsQuickShop", t_19, true);
if(frame.topLevel) {
context.setVariable("analyticsQuickShop", t_19);
}
if(frame.topLevel) {
context.addExport("analyticsQuickShop", t_19);
}
output += "\n                                ";
var t_20;
t_20 = (lineno = 42, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.browseDisplayOptions.pdpShopTheLookTileType","NO_DETAILS"]));
frame.set("defaultTileTemplate", t_20, true);
if(frame.topLevel) {
context.setVariable("defaultTileTemplate", t_20);
}
if(frame.topLevel) {
context.addExport("defaultTileTemplate", t_20);
}
output += "\n\n                                ";
output += "\n                                ";
var t_21;
t_21 = (lineno = 45, colno = 64, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.tileTypeOverride"]));
frame.set("tileTemplateOverride", t_21, true);
if(frame.topLevel) {
context.setVariable("tileTemplateOverride", t_21);
}
if(frame.topLevel) {
context.addExport("tileTemplateOverride", t_21);
}
output += "\n                                ";
var t_22;
t_22 = (runtime.contextOrFrameLookup(context, frame, "tileTemplateOverride")?runtime.contextOrFrameLookup(context, frame, "tileTemplateOverride"):runtime.contextOrFrameLookup(context, frame, "defaultTileTemplate"));
frame.set("tileTemplate", t_22, true);
if(frame.topLevel) {
context.setVariable("tileTemplate", t_22);
}
if(frame.topLevel) {
context.addExport("tileTemplate", t_22);
}
output += "\n\n                                <div class=\"o-slider-product-tray__slide o-slider-product-tray__slide--product-image js-slider__slide js-modal-product-image-zoom-fix\">\n\n                                    ";
output += runtime.suppressValue((lineno = 50, colno = 55, runtime.callWrap(t_4, "displayProductTile", context, [t_14,runtime.memberLookup((t_14),"colorCode"),runtime.memberLookup((t_14),"viewCode"),runtime.memberLookup((t_14),"viewCode"),runtime.makeKeywordArgs({"tileTemplate": runtime.contextOrFrameLookup(context, frame, "tileTemplate"),"displayOverlayControls": runtime.contextOrFrameLookup(context, frame, "True"),"productIndex": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"),"analytics": runtime.contextOrFrameLookup(context, frame, "analytics"),"analyticsQuickShop": runtime.contextOrFrameLookup(context, frame, "analyticsQuickShop"),"displayFavorites": runtime.contextOrFrameLookup(context, frame, "displayFavorites")})])), env.opts.autoescape);
output += "\n\n                                </div>";
;
}
}
frame = frame.pop();
output += "</div>\n\n                    </div>\n\n                    ";
if(!runtime.contextOrFrameLookup(context, frame, "isFullWidth")) {
env.getTemplate("macros/slider-macros.j2", false, "product/templates/product-shop-the-look.j2", false, function(t_24,t_23) {
if(t_24) { cb(t_24); return; }
t_23.getExported(context.getVariables(), frame, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
if(t_23.hasOwnProperty("create_slider_arrows")) {
var t_26 = t_23.create_slider_arrows;
} else {
cb(new Error("cannot import 'create_slider_arrows'")); return;
}
context.setVariable("create_slider_arrows", t_26);
output += runtime.suppressValue((lineno = 63, colno = 45, runtime.callWrap(t_26, "create_slider_arrows", context, [runtime.makeKeywordArgs({"isSmallArrow": runtime.contextOrFrameLookup(context, frame, "True"),"classPrefix": "slider-product-tray"})])), env.opts.autoescape);
output += "\n\n                    ";
})});
}
output += "\n\n                </div>\n\n            </div>\n\n        </div>";
;
}
output += "</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-shop-the-look.j2"] , dependencies)